export default function GiftPoolTips() {
  return (
    <div className="p-6 bg-amber-50">
      <div className="mb-4 text-center">
        <h3 className="font-bold text-amber-900 text-lg">Tips for a Successful Pool</h3>
        <p className="text-[12px] text-amber-700 leading-relaxed italic max-w-xl mx-auto mt-1">
          It's all about building trust so others feel confident gifting you.
        </p>
      </div>
      <ul className="space-y-5">
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">🛡️</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Get vouched</strong>
            Ask someone who knows you personally to vouch for you by tapping the shield button on your post.
            It's one of the strongest signals that your need is legitimate and trustworthy.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">📸</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Add photos and documentation</strong>
            Show your situation. A photo of a medical bill, lease notice, or the thing you need helps
            gifters feel confident they're helping with something real.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">✍️</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Be specific</strong>
            Explain exactly what you need and how the funds will be used. "Cover a $100 rent gap before
            Friday" is clearer than "need help with bills."
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">🧑‍💼</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Make It Personal</strong>
            A clear profile photo and a real name in your post help gifters feel they're supporting a real person.
            Write in your own voice - AI-generated posts can feel generic and are often easy to spot.
            You can use tools for proofreading, but take the time to share your story in your own words.
            Authenticity builds trust.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">💸</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Connect PayPal first</strong>
            Gifters can't contribute until your PayPal is connected. Set it up in Settings before posting
            so your pool opens immediately.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">🔗</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Share your post</strong>
            Send your post link to people who know you. The first few contributions and vouches from
            your own network make strangers much more likely to give.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">💬</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Respond to questions</strong>
            Answering questions or adding updates builds trust and helps others feel comfortable contributing.
          </div>
        </li>
        <li className="flex items-start gap-4">
          <span className="text-lg mt-0.5">🤝</span>
          <div className="text-sm leading-relaxed text-amber-800">
            <strong className="text-amber-900 block mb-0.5">Pay it forward</strong>
            Gift others on Gifted. Your history of giving appears on your profile and makes others more
            likely to help you in return.
          </div>
        </li>
      </ul>
    </div>
  );
}
